/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Range } from './range';


export interface Policy { 
    basedOn?: Policy.BasedOnEnum;
    dateFrom?: string;
    dateTo?: string;
    description?: string;
    id?: number;
    priority?: number;
    ranges?: Array<Range>;
    ruleId?: number;
}
export namespace Policy {
    export type BasedOnEnum = 'CustomerSourceAmount' | 'DestinationAmount' | 'PartnerFees';
    export const BasedOnEnum = {
        CustomerSourceAmount: 'CustomerSourceAmount' as BasedOnEnum,
        DestinationAmount: 'DestinationAmount' as BasedOnEnum,
        PartnerFees: 'PartnerFees' as BasedOnEnum
    };
}
